import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { useAuthState } from "@/hooks/useAuthState";

const Terms = () => {
  const { user } = useAuthState();
  
  useEffect(() => {
    console.log("Terms component mounted", {
      componentName: "Terms",
      mountTime: new Date().toISOString(),
      path: window.location.pathname
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header user={user} />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
          <h1 className="text-3xl font-semibold text-gray-900">Terms of Service</h1>

          <section className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-4">
              By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-2xl font-semibold mb-4">2. Use License</h2>
            <p className="text-gray-600 mb-4">
              Permission is granted to temporarily download one copy of the materials (information or software) on MakeSign's website for personal, non-commercial transitory viewing only.
            </p>

            <h2 className="text-2xl font-semibold mb-4">3. Disclaimer</h2>
            <p className="text-gray-600 mb-4">
              The materials on MakeSign's website are provided on an 'as is' basis. MakeSign makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>

            <h2 className="text-2xl font-semibold mb-4">4. Limitations</h2>
            <p className="text-gray-600 mb-4">
              In no event shall MakeSign or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on MakeSign's website.
            </p>

            <h2 className="text-2xl font-semibold mb-4">5. Revisions and Errata</h2>
            <p className="text-gray-600 mb-4">
              The materials appearing on MakeSign's website could include technical, typographical, or photographic errors. MakeSign does not warrant that any of the materials on its website are accurate, complete or current.
            </p>

            <h2 className="text-2xl font-semibold mb-4">6. Links</h2>
            <p className="text-gray-600 mb-4">
              MakeSign has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by MakeSign of the site.
            </p>

            <h2 className="text-2xl font-semibold mb-4">7. Site Terms of Use Modifications</h2>
            <p className="text-gray-600 mb-4">
              MakeSign may revise these terms of use for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
